import request from '@/utils/request'

/**
 * 得到该账户下所有的菜单配置
 */
export const getMenuByAccountId = (accountId) => {
  return request({
    method: 'GET',
    url: `yia/v1/menu/listMenus/${accountId}`
  })
}

/**
 * 保存某一个菜单配置
 */
export const saveMenu = (data) => {
  return request({
    method: 'POST',
    url: 'yia/v1/menu/save',
    data
  })
}

/**
 *  将该账户的菜单发布到微信
 */
export const publishMenu = (accountId) => {
  return request({
    method: 'GET',
    url: `yia/v1/menu/publish/${accountId}`
  })
}

/**
 * 删除子菜单
 */
export const delMenuItem = (id) => {
  return request({
    method: 'DELETE',
    url: `yia/v1/menu/del/${id}`
  })
}
